import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatTableDataSource,
  MAT_DIALOG_DATA,
  PageEvent,
  MatDatepickerInputEvent,
  MatPaginator,
} from "@angular/material";
import * as moment from "moment";
import { EventInfo } from "../../../_models/eventInfo";
import { BetInfo, Category } from "src/_models/bet";
import { AppService } from "src/_services/app.service";
import { BetsStatusList } from "../../../_constants/bet_filters";
import { Router } from "@angular/router";
import { User } from "src/_models";
import { SapRoles, roleTypeGroup, roleTypeSap } from "src/_constants/roleType";

type BetListFilters = {
  userName?: string;
  userId: string;
  sportId?: string;
  eventId?: string;
  marketId?: string;
  status?: string;
  startTime?: number;
  endTime?: number;
  Page?: number;
  PageSize?: number;
  providerId: string;
  operatorId: string;
  sportName?: string;
  transactionId?: string;
};

export interface DialogData {
  betInfo: BetInfo;
}

@Component({
  selector: "app-bet-list",
  templateUrl: "./bet-list.component.html",
  styleUrls: ["./bet-list.component.scss"],
})
export class BetListComponent implements OnInit {
  betListFilters: BetListFilters;
  betDisplayedColumns: string[] = [
    "Date",
    "Username",
    "Sports",
    "Event",
    "OperatorId",
    "MarketType",
    "Odds",
    "Stake",
    "currency",
    "status",
    "Returns",
  ];

  today = new Date();
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  formDate = new FormControl(this.today);
  toDate = new FormControl(new Date(this.today.getTime() + 86400000));
  bets = new MatTableDataSource<any>();
  users: User[] = [];
  filterUsers: User[] = [];
  events: EventInfo[] = [];
  selectedEvent: string = "all";
  totalRecords: number;
  searchUserName: string = "all";
  sapRoles = SapRoles;
  sports = [];
  operatoridfilter: boolean = false;
  useridfilter: boolean = false;
  transactionfilter: boolean = false;
  eventidfilter: boolean = false;
  marketidfilter: boolean = false;
  ipfilter: boolean = false;
  ipfill() {
    this.ipfilter = true;
  }
  transactionfi() {
    this.transactionfilter = true;
  }
  useridfil() {
    this.useridfilter = true;
  }

  eventidfil() {
    this.eventidfilter = true;
  }

  marketidfil() {
    this.marketidfilter = true;
  }
  originfill() {
    this.originfilter = true;
  }
  categoryfill() {
    this.categoryfilter = true;
  }

  showAlert: any = false;

  betStatusList = [].concat(BetsStatusList);

  selectedProvider = "";
  selectedIP = "";
  selectedBetId = "";
  selectedEventId = "";
  selectedMarketId = "";
  selectedSport = new FormControl([]);
  selectedBetStatus = new FormControl([this.betStatusList[1]]);
  selectedUserName = "";
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  
  selected: any = {
    startDate: moment().subtract(3, "days"),
    endDate: moment(),
  };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  ProviderId = new FormControl([]);
  OperatorId = new FormControl([]);
  operatorData = [];
  length: any = 0;
  dropdownSettings: any = {};
  operatorSettings: any = {};
  sportSettings: any = {};
  statusSettings: any = {};
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  origin = new FormControl([]);
  category = new FormControl([]);
  originfilter: boolean = false;
  categoryfilter: boolean = false;
  show = false;
  categories = Category;
  origins = ["SPORTSBOOK","PREMIUM","VIRTUAL","EXPREMIUM"];
  savedFilters: any = null;
  readonly filtersPageKey = "bet-list";

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  changeTableColumns() {
    this.betDisplayedColumns =
    this.userRole.role === this.sapRoles.SAPAdmin ||
    roleTypeGroup.includes(this.userRole.role) ||
    this.userRole.role === this.sapRoles.RiskAdmin
    ? this.ProviderId.value[0] === "SportsBook" ?
      [
        "Date",
        "AcceptedTime",
        "Username",
        "Sports",
        "Event",
        "OperatorId",
        "MarketType",
        "Odds",
        "Stake",
        "Profit",
        "currency",
        "status",
        "Returns",
        "Origin"
      ]
      : [
        "Date",
        "Username",
        "Sports",
        "Event",
        "OperatorId",
        "MarketType",
        "Odds",
        "Stake",
        "currency",
        "status",
        "Returns",
        "IscashedOut"
      ]
      : this.ProviderId.value[0] === "SportsBook" ?[
          "Date",
          "AcceptedTime",
          "Username",
          "Sports",
          "Event",
          "MarketType",
          "Odds",
          "Stake",
          "Profit",
          "currency",
          "status",
          "Returns",
          "Origin"
        ]: [
          "Date",
          "Username",
          "Sports",
          "Event",
          "MarketType",
          "Odds",
          "Stake",
          "currency",
          "status",
          "Returns",
        ]
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.operatorSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    // this.getOurProviders();
    sessionStorage.setItem("TotalBets", "0");
    this.getOperatorData();
    this.appService.getFilters(this.filtersPageKey).subscribe(
      (res) => {
        if (res.status === "RS_OK" && res.filters && Object.keys(res.filters).length) {
          this.savedFilters = res.filters;
          this.applySavedFilters();
        }
        this.getAdminProviders();
      },
      () => {
        this.getAdminProviders();
      }
    );
    if (roleTypeSap.includes(this.userRole.role) || this.providers.includes("SportsBook")) {
      this.show = true;
    }
    // this.getBetList();
  }

  applySavedFilters() {
    const f = this.savedFilters;
    if (f.operatorId && f.operatorId.length) {
      this.OperatorId.setValue(f.operatorId);
    }
    if (f.status != null) {
      const matchedStatus = this.betStatusList.find((s) => s.id === f.status);
      if (matchedStatus) {
        this.selectedBetStatus.setValue([matchedStatus]);
      }
    }
    if (f.startTime || f.endTime) {
      // Reassign (not mutate) - ngxDaterangepickerMd only re-renders when the
      // bound object reference changes.
      this.selected = {
        startDate: f.startTime ? moment.unix(f.startTime) : this.selected.startDate,
        endDate: f.endTime ? moment.unix(f.endTime) : this.selected.endDate,
      };
    }
  }

  saveFilters() {
    const filters = {
      providerId: this.ProviderId.value[0],
      operatorId: this.OperatorId.value.length === 0 ? [] : this.OperatorId.value,
      sportId: this.selectedSport.value[0].SportId === 'All' ? "" : this.selectedSport.value[0].SportId,
      status: this.selectedBetStatus.value[0].id,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };
    this.appService.saveFilters(this.filtersPageKey, filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.appService.openSuccessBar(res.errorDescription);
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      }
    });
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  onSelectedBetsType = (data) => {
    this.page = 1;
    this.paginator.pageIndex = 0;
    this.selectedBetStatus = data;
    this.getBetList();
  };

  getAdminProviders() {
    if (this.userRole.role === this.sapRoles.SAPAdmin) {
      this.providers = ["Exchange", "SportsBook", "GeniusPremium"];
    } else if (
      this.userRole.role === this.sapRoles.SAPUser ||
      this.userRole.role === this.sapRoles.RiskAdmin
    ) {
      this.providers = ["Exchange", "SportsBook"];
    }
    const savedProviderId = this.savedFilters && this.savedFilters.providerId;
    const defaultProvider =
      savedProviderId && this.providers.includes(savedProviderId)
        ? savedProviderId
        : this.providers[0];
    this.onSelectedProvider(defaultProvider);
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getBetList();
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators
            .sort((a, b) => {
              let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .map((operator) => {
              return operator.operator_id;
            });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          this.sports.unshift({ SportId: "All", SportName: "All Sports" });
          let sportIndex = -1;
          if (this.savedFilters && this.savedFilters.sportId != null) {
            // "" means All Sports (SportId "All"); otherwise match by SportId
            const targetSportId = this.savedFilters.sportId === "" ? "All" : this.savedFilters.sportId;
            sportIndex = this.sports.findIndex(sport => sport.SportId === targetSportId);
          }
          if (sportIndex === -1) {
            sportIndex = this.sports.findIndex(sport => sport.SportName.toLowerCase() === 'cricket');
          }
          if (sportIndex === -1) {
            sportIndex = 0;
          }
          this.selectedSport.setValue([this.sports[sportIndex]]);
          this.savedFilters = null;
          this.onFilterChange();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.page = 1;
    this.ProviderId.setValue([pid]);
    this.changeTableColumns();
    if (this.paginator) {
    this.paginator.pageIndex = 0;
    }
  };

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getBetList();
  }

  onSelectedOperatorId = (OperatorId) => {
    this.page = 1;
    this.OperatorId.setValue(OperatorId);
    this.getBetList();
    this.paginator.pageIndex = 0;
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      } else if (this.selected.startDate !== null) {
        this.getBetList();
      }
    }
  };

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getExportExcel() {
    let filters = {
      providerId: this.ProviderId.value[0],
      operatorId: this.OperatorId.value.length === 0 ? [] : this.OperatorId.value,
      userName: this.selectedUserName ? this.selectedUserName : null,
      userId: this.selectedUserName ? this.selectedUserName : null,
      origin: this.origin.value.length != 0 ? this.origin.value : [],
      category: this.category.value.length != 0 ? this.category.value[0].id : "",
      eventId: this.selectedEventId,
      marketId: this.selectedMarketId,
      sportIds: this.selectedSport.value[0].SportId === 'All'
      ? this.sports.filter(sport => sport.SportId !== 'All')
          .map(sport => sport.SportId)
      : [this.selectedSport.value[0].SportId],
      status: this.selectedBetStatus.value[0].id,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getExportExcel(filters).subscribe((res) => {
      const contentType = "application/vnd.ms-excel";
      let blob1 = this.b64toBlob(res.file, contentType);
      let blobUrl1 = URL.createObjectURL(blob1);
      const link = document.createElement("a");
      link.href = blobUrl1;
      link.setAttribute("download", `bet_list.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  }

  getBetList() {
    const pagination = {
      Number: 10,
      Page: 1,
    };
    let filters;
    if (this.selectedBetId == "" || this.selectedBetId == null) {
    filters = {
      providerId: this.ProviderId.value[0],
      operatorId: this.OperatorId.value.length === 0 ? null : this.OperatorId.value,
      userName: this.selectedUserName ? this.selectedUserName : null,
      origin: this.origin.value.length != 0 ? this.origin.value : [],
      category: this.category.value.length != 0 ? this.category.value[0].id : "",
      userId: this.selectedUserName ? this.selectedUserName : null,
      sportIds: this.selectedSport.value[0].SportId === 'All'
      ? this.sports.filter(sport => sport.SportId !== 'All')
          .map(sport => sport.SportId)
      : [this.selectedSport.value[0].SportId],
      status: this.selectedBetStatus.value[0].id,
      transactionId: this.selectedBetId.toLowerCase(),
      eventId: this.selectedEventId,
      marketId: this.selectedMarketId,
      ip: this.selectedIP,
      startTime:
        this.selected.startDate !== null
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      PageSize: this.orgPageSize,
      Page: this.page,
    }; } else {
      filters = {
        transactionId: this.selectedBetId.toLowerCase(),
      }
    }
    this.appService.getBetList(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.bets = new MatTableDataSource<any>(res.betList);
        if (this.page == 1) {
          this.length = res.totalBets;
        } else {
          this.paginator.length = this.length;
        }
      }
    });
  }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  };

  onChangeSports(sport) {
    this.page = 1;
    this.selectedSport = sport;
    this.getBetList();
  }

  onChangeEvent() {
    this.getBetList();
  }

  onChangeUser() {
    this.getBetList();
  }

  onChangeStatus() {
    this.getBetList();
  }

  onBetIdSelection(value) {
    this.selectedBetId = value.trim();
  }

  onBetIdSelectionClear() {
    if (this.selectedBetId == "" || this.selectedBetId == null) {
      this.transactionfilter = false;
    }
    this.selectedBetId = "";
  }

  onIPSelection(value) {
    this.selectedIP = value.trim();
  }

  onIPSelectionClear() {
    if (this.selectedIP == "" || this.selectedIP == null) {
      this.ipfilter = false;
    }
    this.selectedIP = "";
  }

  onEventIdSelection(value) {
    this.selectedEventId = value.trim();
  }

  onEventIdSelectionClear() {
    if (this.selectedEventId == "" || this.selectedEventId == null) {
      this.eventidfilter = false;
    }
    this.selectedEventId = "";
  }

  onMarketIdSelection(value) {
    this.selectedMarketId = value.trim();
  }

  onMarketIdSelectionClear() {
    if (this.selectedMarketId == "" || this.selectedMarketId == null) {
      this.marketidfilter = false;
    }
    this.selectedMarketId = "";
  }

  onUserSelection(user: User) {
    this.selectedUserName = user.userId;
    this.getBetList();
  }

  onUserSelectionClear() {
    if (this.selectedUserName == "" || this.selectedUserName == null) {
      this.useridfilter = false;
    }
    this.selectedUserName = null;
  }

  openDialog(betDetails: BetInfo) {
    this.dialog.open(BetDetailsModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        betInfo: betDetails,
      },
    });
  }
}

// Bet details PopupModal
@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./bet_info_modal.component.html",
  styleUrls: ["./bet-list.component.scss"],
})
export class BetDetailsModalComponent {
  betInfo: BetInfo;
  betResponse: BetInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private appService: AppService
  ) {
    if (data.betInfo) {
      this.betInfo = data.betInfo;
    }
  }

  ngOnInit() {
    if (this.betInfo.transactionId) {
      this.appService
        .getBetInfo(this.betInfo.transactionId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.betResponse = res.betReportDetail;
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              // this.router.navigateByUrl("/login");
            }
          }
        });
    }
  }

  copyEvent() {
    return this.betInfo.sportName + "/" + this.betInfo.eventName
  }

  betOn() {
    const value = this.betInfo.marketType === "FANCY" ? "FANCY" :
  this.betInfo.marketName + "/" +
  (this.betInfo.marketType === "FANCY" ?
    this.betInfo.runnerName + "@" + this.betResponse.odds :
    this.betInfo.runnerName);

return value;
  }

  copyText(val: string){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

  getBetPlaceDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  };
}
